import {Accordion, Box, Divider, List, ListItem} from '@chakra-ui/react'
import { SidebarItemLink } from "../../molecules/SidebarItemLink";
import { KuitanAgentName } from "../../atoms/KuitanAgentName";
import React from "react";

export const KuitanAgentSidebarMenu = () => {
  const menuItems = [
    { component: <SidebarItemLink to='' text="基本情報" />, key: 'basic-info' },
    { component: <SidebarItemLink to='ratings' text="評価" />, key: 'ratings' },
  ];
  return (
    <Accordion allowMultiple>
        <Divider m='0' />
        <Box px={4} py={3} fontWeight="bold" fontSize="md">
            <KuitanAgentName />
        </Box>
        <Divider m='0' />
      <List spacing={1}>
        {menuItems.map(item => (
          <ListItem key={item.key} fontWeight="bold">
            {item.component}
          </ListItem>
        ))}
      </List>
    </Accordion>
  );
};